import {takeEvery, put, select} from 'redux-saga/effects';
import getCashbackSummaryApi, {
  createCashbackSettingsApi,
  getCashbackSettingsApi,
  updateCashbackSettingsApi
} from 'helpers/services/api/cashback';
import {
  GET_CASHBACK_SETTINGS,
  GET_CASHBACK_SETTINGS_SUCCESS,
  GET_CASHBACK_SUMMARY,
  GET_CASHBACK_SUMMARY_SUCCESS,
  SAVE_CASHBACK_SETTINGS,
  SET_CASHBACK_SETTINGS_LOADING,
  SET_LOADING
} from 'store/cashback/action';

function* getCashbackSummary() {
  try {
    yield put(SET_LOADING(true));

    const locationId = yield select((state) => state.user?.activeLocation?._id);

    if (!locationId) {
      yield put(SET_LOADING(false));
      return;
    }

    const {data} = yield getCashbackSummaryApi(locationId);
    if (data?.data) {
      yield put(GET_CASHBACK_SUMMARY_SUCCESS(data.data));
    }
    yield put(SET_LOADING(false));
  } catch (error) {
    yield put(SET_LOADING(false));
    console.log('CASHBACK SAGA ERROR', error);
  }
}

function* getCashbackSettings() {
  try {
    yield put(SET_CASHBACK_SETTINGS_LOADING(true));

    const locationId = yield select((state) => state.user?.activeLocation?._id);

    if (!locationId) {
      yield put(SET_CASHBACK_SETTINGS_LOADING(false));
      return;
    }

    const response = yield getCashbackSettingsApi(locationId);
    yield put(GET_CASHBACK_SETTINGS_SUCCESS(response?.data || null));
    yield put(SET_CASHBACK_SETTINGS_LOADING(false));
  } catch (error) {
    yield put(GET_CASHBACK_SETTINGS_SUCCESS(null));
    yield put(SET_CASHBACK_SETTINGS_LOADING(false));
  }
}

function* saveCashbackSettings({payload}) {
  const {settingsId, data, onSuccess, onError} = payload || {};

  try {
    let response;

    if (settingsId) {
      response = yield updateCashbackSettingsApi(settingsId, data);
    } else {
      response = yield createCashbackSettingsApi(data);
    }

    yield put(GET_CASHBACK_SETTINGS_SUCCESS(response?.data || null));

    if (typeof onSuccess === 'function') {
      onSuccess(response?.data || null);
    }
  } catch (error) {
    if (typeof onError === 'function') {
      onError(error);
    }
  }
}

function* cashbackSaga() {
  yield takeEvery(GET_CASHBACK_SUMMARY, getCashbackSummary);
  yield takeEvery(GET_CASHBACK_SETTINGS, getCashbackSettings);
  yield takeEvery(SAVE_CASHBACK_SETTINGS, saveCashbackSettings);
}

export default cashbackSaga;
